/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Medialibraryinfodimensions3Inputs */

const en_medialibraryinfodimensions3 = /** @type {(inputs: Medialibraryinfodimensions3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dimensions`)
};

const de_medialibraryinfodimensions3 = /** @type {(inputs: Medialibraryinfodimensions3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abmessungen`)
};

/**
* | output |
* | --- |
* | "Dimensions" |
*
* @param {Medialibraryinfodimensions3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const medialibraryinfodimensions3 = /** @type {((inputs?: Medialibraryinfodimensions3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Medialibraryinfodimensions3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_medialibraryinfodimensions3(inputs)
	return de_medialibraryinfodimensions3(inputs)
});
export { medialibraryinfodimensions3 as "mediaLibraryInfoDimensions" }